import type { LngLatLike } from 'mapbox-gl';

/** A pin (marker) on the map representing a visited location */
export interface Pin {
  id: string;
  tripId: string;
  userId: string;
  latitude: number;
  longitude: number;
  title: string | null;
  description: string | null;
  visitDate: string | null;
  countryCode: string | null;
  city: string | null;
  createdAt: string;
  updatedAt: string;
  /** Number of photos at this pin */
  photoCount?: number;
  /** Optional first photo thumbnail URL */
  thumbnailUrl?: string;
  /** Trip color for marker differentiation */
  tripColor?: string;
}

/** Data needed to create a new pin */
export interface CreatePinData {
  tripId: string;
  latitude: number;
  longitude: number;
  title?: string;
  description?: string;
  visitDate?: string;
}

/** Data needed to update an existing pin */
export interface UpdatePinData {
  title?: string;
  description?: string;
  visitDate?: string;
}

/** GeoJSON feature for a pin (used in clustering) */
export interface PinGeoJsonProperties {
  id: string;
  tripId: string;
  title: string | null;
  visitDate: string | null;
  thumbnailUrl?: string;
  tripColor?: string;
  photoCount?: number;
}

/** Mapbox style identifiers */
export type MapStyle = 'streets' | 'satellite';

export const MAP_STYLES: Record<MapStyle, string> = {
  streets: 'mapbox://styles/mapbox/streets-v12',
  satellite: 'mapbox://styles/mapbox/satellite-streets-v12',
};

/** Map interaction modes */
export type MapMode = 'view' | 'add-pin';

/** Map viewport state */
export interface MapViewport {
  center: LngLatLike;
  zoom: number;
  bearing: number;
  pitch: number;
}

/** Response from GET /api/v1/locations/pins */
export interface PinsResponse {
  pins: Pin[];
  total: number;
}
